import { Grid, Switch } from '@mui/material';
import { styled } from '@mui/styles';
import { FC } from 'react';
import { FormProvider, Controller, useForm } from 'react-hook-form';
import { Label } from 'wisestep-base';

export interface JobAttrSingleProps {
  adminSwitchValue: boolean;
  dataCallback(data: boolean): void;
}
export const StyledSwitch = styled(Switch)(() => ({
  top: '0.5vw',
}));
const JobAttrSingle: FC<JobAttrSingleProps> = ({ adminSwitchValue, dataCallback }) => {
  const formDefaultValues = {
    value: adminSwitchValue,
  };
  const formOptions = {
    defaultValues: formDefaultValues,
  };
  const methods = useForm(formOptions);
  const { control } = methods;
  return (
    <FormProvider {...methods}>
      <Grid container direction="row" maxHeight={20}>
        <Grid item xs={8}>
          <Label sx={{ fontWeight: 'bold' }}>
            Allow job admins to customize these for each job
          </Label>
        </Grid>
        <Grid item xs={2}>
          <Controller
            name="value"
            control={control}
            render={(props) => (
              <StyledSwitch
                defaultChecked={props.field.value}
                onChange={(_event, checked) => dataCallback(checked)}
              />
            )}
          />
        </Grid>
      </Grid>
    </FormProvider>
  );
};
export default JobAttrSingle;
